import {forwardRef, useEffect, useState} from "react";
import {mobileImage} from "../mobileAssets";

const TAPTAP_VISIBLE_AT = new Date("2026-08-21T12:00:00+08:00").getTime();

const HomeScreen = forwardRef(function HomeScreen({onReserve, onShowCharacters}, ref) {
    const [isTapTapVisible, setIsTapTapVisible] = useState(() => Date.now() >= TAPTAP_VISIBLE_AT);

    useEffect(() => {
        if (isTapTapVisible) return undefined;
        const timerId = window.setTimeout(() => setIsTapTapVisible(true), Math.max(0, TAPTAP_VISIBLE_AT - Date.now()));
        return () => window.clearTimeout(timerId);
    }, [isTapTapVisible]);

    return (
        <div ref={ref} className="page_one mobile-home-page mobile-section-page">
            <p className="mobile-quality-note">*游戏研发中，非最终品质。</p>
            <img className="mobile-home-hero" src={mobileImage("homev.jpg")} alt="失乐枷锁角色主视觉"/>
             <img className="mobile-home-play" src={mobileImage("plays_03.png")} alt="播放"/>
            <div className="mobile-home-shade" aria-hidden="true"/>
            <section className="mobile-home-content">
                <p>奏 响 定 义 幸 福 的 世 界 里</p>
                <h1>爱是唯一失控的变量</h1>
                <div className="mobile-home-actions">
                    <button type="button" onClick={onReserve} aria-label="立即预约">
                        <img src={mobileImage("bbtn_03.jpg")} alt="立即预约"/>
                    </button>
                    {isTapTapVisible ? <a href="https://www.taptap.cn/app/882858" target="_blank" rel="noreferrer" aria-label="TapTap预约">
                        <img src={mobileImage("bbtn_05.jpg")} alt="TapTap预约"/>
                    </a> : null}
                </div>
            </section>
            <button className="mobile-home-down" type="button" onClick={onShowCharacters} aria-label="查看角色介绍">
            <img src={mobileImage("three_13.png")} className="down" alt="向下浏览"/>
            </button>
        </div>
    );
});

export default HomeScreen;
